var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { FromJSON } from "js-vextensions";
import { runInAction } from "mobx";
import { ApplyDBUpdates } from "mobx-firelink";
import { Button, Row, Select, Switch, Text } from "react-vcomponents";
import { BaseComponentPlus } from "react-vextensions";
import { AddSeed } from "Server/Commands/AddSeed";
import { store } from "Store";
import { GetBook, GetBooks } from "Store/firebase/books";
import { GetCharacters } from "Store/firebase/characters";
import { GetEvents } from "Store/firebase/events";
import { MapUI } from "UI/Write/MapUI";
import { GenerateUUID } from "Utils/General/KeyGenerator";
import { Observer } from "vwebapp-framework";
import { AddBookEvent } from "../Server/Commands/AddBookEvent";
import { BookEvent } from "../Store/firebase/events/@BookEvent";
import { GetSeeds } from "../Store/firebase/seeds";
import { Seed } from "../Store/firebase/seeds/@Seed";
import { GetUsers, MeID } from "../Store/firebase/users";
import { SubNavBar, SubNavBarButton } from "./@Shared/SubNavBar";
import { ShowAddBookDialog } from "./Write/BookDetailsUI";
import { CharactersUI } from "./Write/Characters";
import { EventsUI } from "./Write/Events";
import { NotesUI } from "./Write/NotesUI";
import { SeedsUI } from "./Write/Seeds";
import { WriteOthersDropDown } from "./Write/WriteOthersDropDown";
let WriteUI = class WriteUI extends BaseComponentPlus({}, {}) {
    render() {
        const selectedBookID = store.main.write.selectedBook;
        const currentSubpage = store.main.write.subpage;
        const books = GetBooks(MeID());
        const selectedBook = GetBook(selectedBookID);
        const userCount = GetUsers().length;
        const page = "write";
        return (React.createElement(React.Fragment, null,
            React.createElement(Row, { style: { position: "absolute", zIndex: 1, left: 0, right: 0, top: 0, flex: "0 0 28px" } },
                React.createElement(Row, { center: true },
                    React.createElement(Text, { ml: 5 }, "Book: "),
                    React.createElement(Select, { options: [{ name: "", value: null }].concat(books), value: books.find(a => a._key == selectedBookID), onChange: val => runInAction("WriteUI.Book.onChange", () => store.main.write.selectedBook = val ? val._key : null) }),
                    React.createElement(Button, { text: "+", ml: 5, onClick: () => {
                            ShowAddBookDialog(MeID());
                        } }),
                    React.createElement(ImportButton, null)),
                React.createElement(SubNavBar, null,
                    React.createElement(SubNavBarButton, Object.assign({}, { page }, { subpage: "notes", text: "Notes" })),
                    React.createElement(SubNavBarButton, Object.assign({}, { page }, { subpage: "map", text: "Map" })),
                    React.createElement(SubNavBarButton, Object.assign({}, { page }, { subpage: "characters", text: "Characters" })),
                    React.createElement(SubNavBarButton, Object.assign({}, { page }, { subpage: "seeds", text: "Seeds" })),
                    React.createElement(SubNavBarButton, Object.assign({}, { page }, { subpage: "events", text: "Events" })),
                    React.createElement(SubNavBarButton, Object.assign({}, { page }, { subpage: "narrative", text: "Narrative" })),
                    React.createElement(SubNavBarButton, Object.assign({}, { page }, { subpage: "text", text: "Text" }))),
                React.createElement(Row, { ml: "auto" },
                    React.createElement(WriteOthersDropDown, null))),
            React.createElement(Switch, null,
                React.createElement(NotesUI, { book: selectedBook }),
                currentSubpage == "map" && React.createElement(MapUI, { book: selectedBook }),
                currentSubpage == "characters" && React.createElement(CharactersUI, { bookID: selectedBookID }),
                currentSubpage == "seeds" && React.createElement(SeedsUI, { bookID: selectedBookID }),
                currentSubpage == "events" && React.createElement(EventsUI, { bookID: selectedBookID }))));
    }
};
WriteUI = __decorate([
    Observer
], WriteUI);
export { WriteUI };
let ImportButton = class ImportButton extends BaseComponentPlus({}, {}) {
    render() {
        const selectedBook = store.main.write.selectedBook;
        const characters = GetCharacters(selectedBook);
        const seeds = GetSeeds(selectedBook);
        const events = GetEvents(selectedBook);
        return (React.createElement(Button, { text: "Import", ml: 5, enabled: selectedBook != null, onClick: async () => {
                const input = document.createElement("input");
                input.type = "file";
                input.click();
                input.onchange = () => {
                    const file = input.files[0];
                    const reader = new FileReader();
                    reader.onload = async function (e) {
                        const text = reader.result;
                        const data = FromJSON(text.toString());
                        const dbUpdates = {};
                        for (const list of data.lists) {
                            const cards = data.cards.filter(a => a.idList == list.id);
                            if (list.name == "[Someone]") {
                                let newCards = cards.filter(a => !seeds.Any(b => b.text == a.name));
                                if (newCards.length == 0)
                                    continue;
                                newCards = newCards.slice(0, 200); // do at most X at a time, otherwise call might fail
                                if (confirm(`Do you want to import the new cards (${newCards.length}) in list "${list.name}" as seeds?`)) {
                                    //for (let card of newCards.slice(0, 100)) { // only do 100 at a time, otherwise seems to just never complete call
                                    // make sure you run import from the "characters" page -- on the "Seeds" page, it can be so slow that call never completes
                                    for (const card of newCards) {
                                        const seed = new Seed({ book: selectedBook, text: card.name });
                                        const command = new AddSeed({ seed });
                                        /*command.Validate_Early();
                                        await command.Prepare();
                                        await command.Validate();*/
                                        command.id = GenerateUUID();
                                        dbUpdates.VSet(command.GetDBUpdates());
                                    }
                                }
                            }
                            else {
                                const char = characters.find(a => a.name == list.name);
                                if (char == null) {
                                    alert(`Character not found for list "${list.name}", so skipping.`);
                                    continue;
                                }
                                let newCards = cards.filter(a => !events.Any(b => b.text == a.name));
                                if (newCards.length == 0)
                                    continue;
                                newCards = newCards.slice(0, 200); // do at most X at a time, otherwise call might fail
                                if (confirm(`Do you want to import the new cards (${newCards.length}) in list "${list.name}" as events for character "${char.name}"?`)) {
                                    for (const card of newCards) {
                                        const event = new BookEvent({
                                            book: selectedBook,
                                            characters: {
                                                [char._key]: { _: true },
                                            },
                                            text: card.name,
                                        });
                                        const command = new AddBookEvent({ event });
                                        /*command.Validate_Early();
                                        await command.Prepare();
                                        await command.Validate();*/
                                        command.id = GenerateUUID();
                                        dbUpdates.VSet(command.GetDBUpdates());
                                    }
                                }
                            }
                        }
                        await ApplyDBUpdates({}, dbUpdates);
                        alert("Import complete!");
                    };
                    reader.readAsText(file);
                };
            } }));
    }
};
ImportButton = __decorate([
    Observer
], ImportButton);
